/** Content for an `undefined` or `null` data table cell */
export const EmptyCell: React.FC = () => (
  <span className="inline-block w-full text-dm-charcoal-200">&mdash;</span>
);
